/**
 * @fileoverview GET handler for the "/engagement/report_dashboard/:dashboard_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportDashboardDashboardId } from "./constants";
import type { EngagementReportDashboardDashboardIdResult } from "./types";

export const getEngagementReportDashboardDashboardId = reactQueryFetcherAdapter(
  engagementReportDashboardDashboardId,
  (
    signal: AbortSignal,
    dashboardId: string,
    /**
     * Pass false to omit `run_event` from the response. Its cached query results hold
     * whatever the dashboard's SQL returned from Snowflake, so callers that only need the
     * dashboard's configuration should opt out.
     *
     * Required rather than optional because `ExtractArgsFromQueryKey` infers this fetcher's
     * argument tuple from its signature, and an optional trailing parameter widens to
     * `boolean | undefined`, which `CacheKeyParam` does not admit.
     */
    includeRunResults: boolean
  ): Promise<EngagementReportDashboardDashboardIdResult> => {
    const params = includeRunResults ? {} : { include_run_results: false };

    return fetch(`/engagement/report_dashboard/${dashboardId}`, "GET", params, { signal });
  }
);
